export enum NewYearItems {
  PrimaryWreath = 'primary_wreath_new_year',
  HighlightedWreath = 'highlighted_wreath_new_year'
}
